import { SetActive } from '@clerk/types';

type HandleClerkRedirectParams = {
  sessionId: string;
  redirectTo?: string;
  setActive: SetActive;
  allowedCustomSchemes?: string[];
  onAfterSuccess?: () => void;
};

export default async function handleSetActive({
  sessionId,
  redirectTo,
  setActive,
  allowedCustomSchemes = ['boatsetter-renters', 'boatsetter-owners'],
  onAfterSuccess = () => {
    // noop
  },
}: HandleClerkRedirectParams): Promise<void> {
  if (!sessionId) throw new Error('Missing session ID');

  const isCustomScheme = redirectTo && allowedCustomSchemes.some((scheme) => redirectTo.startsWith(scheme));

  if (isCustomScheme) {
    await setActive({ session: sessionId });
    window.location.href = `/api/auth/token-exchange?redirect_to=${redirectTo}`;
  } else {
    await setActive({ session: sessionId, redirectUrl: redirectTo });
  }

  return onAfterSuccess();
}
